module.exports = __webpack_public_path__ + "img/data_secure.510454ee.svg";